"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var _Mon317CarouselData = _interopRequireDefault(require("pricing-pages-unified-ui/components/cms-hub-page/Mon317CarouselData"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _colors = require("HubStyleTokens/colors");

var _Mon317CarouselDots = _interopRequireDefault(require("pricing-pages-unified-ui/components/cms-hub-page/Mon317CarouselDots"));

var _Mon317CarouselModal = _interopRequireDefault(require("pricing-pages-unified-ui/components/cms-hub-page/Mon317CarouselModal"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  transition: transform 0.2s;\n  &:hover {\n    transform: scale(1.1);\n  }\n  &:active {\n    transform: scale(0.9);\n  }\n  cursor: pointer;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  grid-column-gap: 24px;\n  max-width: 800px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  opacity: 0;\n  transition: opacity 0.5s;\n  cursor: pointer;\n\n  &.selected {\n    opacity: 1;\n  }\n\n  &:not(:first-of-type) {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    top: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CrossFadeImage = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "Mon317Carousel__CrossFadeImage",
  componentId: "h9n4gd-0"
})(_templateObject());

var CenterContainer = _styledComponents.default.div.withConfig({
  displayName: "Mon317Carousel__CenterContainer",
  componentId: "h9n4gd-1"
})(_templateObject2());

var ScreenshotWrapper = _styledComponents.default.div.withConfig({
  displayName: "Mon317Carousel__ScreenshotWrapper",
  componentId: "h9n4gd-2"
})(_templateObject3());

var Arrow = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "Mon317Carousel__Arrow",
  componentId: "h9n4gd-3"
})(_templateObject4(), _colors.CALYPSO); // An index hook that wraps around 0 / max

var useIndex = function useIndex(initial, max) {
  var _useState = (0, _react.useState)(initial),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var incrementIndex = function incrementIndex() {
    return setIndex(function (oldIndex) {
      return (oldIndex + 1) % max;
    });
  };

  var decrementIndex = function decrementIndex() {
    return setIndex(function (oldIndex) {
      return oldIndex === 0 ? max - 1 : oldIndex - 1;
    });
  };

  return [index, setIndex, incrementIndex, decrementIndex];
};

var Mon317Carousel = function Mon317Carousel(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  var NUM_CUSTOMERS = 73400;

  var _useIndex = useIndex(0, _Mon317CarouselData.default.length),
      _useIndex2 = (0, _slicedToArray2.default)(_useIndex, 4),
      index = _useIndex2[0],
      setIndex = _useIndex2[1],
      increment = _useIndex2[2],
      decrement = _useIndex2[3];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      modalOpen = _useState4[0],
      setModalOpen = _useState4[1];

  var trackEvent = function trackEvent(action) {
    var trackIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : index;
    return (0, _getUsageTracker.default)().track('carouselInteraction', {
      action: action,
      imageId: _Mon317CarouselData.default[trackIndex].trackingId,
      sourceId: 'cms-hub-social-proof'
    });
  };

  var handleRightArrow = function handleRightArrow() {
    trackEvent('next-image');
    increment();
  };

  var handleLeftArrow = function handleLeftArrow() {
    trackEvent('previous-image');
    decrement();
  };

  var handleModalOpen = function handleModalOpen() {
    trackEvent('expand-image');
    setModalOpen(true);
  };

  var handleDotClick = function handleDotClick(newIndex) {
    trackEvent('jump-to-image', newIndex);
    setIndex(newIndex);
  };

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classNames.default)('flex-column text-center align-center', className)
  }, rest), _react.default.createElement("h1", null, _react.default.createElement(_FormattedReactMessage.default, {
    message: "mon317.carouselTitle",
    options: {
      numCustomers: _react.default.createElement(_FormattedNumber.default, {
        value: NUM_CUSTOMERS
      })
    }
  })), _react.default.createElement(_FormattedMessage.default, {
    message: "mon317.carouselSubtitle"
  }), _react.default.createElement(CenterContainer, {
    className: "m-top-10"
  }, _react.default.createElement("div", {
    className: "align-center"
  }, _react.default.createElement(Arrow, {
    size: "sm",
    name: "left",
    onClick: handleLeftArrow
  })), _react.default.createElement(ScreenshotWrapper, null, _Mon317CarouselData.default.map(function (_ref2, i) {
    var screenshot = _ref2.screenshot,
        alt = _ref2.alt;
    return _react.default.createElement(CrossFadeImage, {
      key: alt,
      alt: alt,
      src: screenshot,
      onClick: handleModalOpen,
      className: (0, _classNames.default)(index === i && 'selected')
    });
  })), _react.default.createElement("div", {
    className: "align-center"
  }, _react.default.createElement(Arrow, {
    size: "sm",
    name: "right",
    onClick: handleRightArrow
  }))), _react.default.createElement("div", {
    style: {
      fontSize: 12,
      cursor: 'pointer'
    },
    className: "m-top-3",
    onClick: handleModalOpen
  }, _react.default.createElement(_FormattedMessage.default, {
    message: 'mon317.clickToEnlarge'
  })), _react.default.createElement(_Mon317CarouselDots.default, {
    length: _Mon317CarouselData.default.length,
    setSelectedIndex: handleDotClick,
    selectedIndex: index,
    className: "m-top-4"
  }), _react.default.createElement(_Mon317CarouselModal.default, {
    open: modalOpen,
    closeModal: function closeModal() {
      return setModalOpen(false);
    },
    screenshotIndex: index
  }));
};

var _default = Mon317Carousel;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-hub-page/Mon317Carousel.js
// module id = 876
// module chunks = 5 6